import { Dialog } from '@ymba/ym-ui';
import { orderPreCheck, cancelOrder } from '@/services/order';
import { commonLog } from '@/services/app';
import promptMessageMixin from '@/mixins/message/prompt';

const preCheckMixin = {
  mixins: [promptMessageMixin],
  data() {
    return {
      mixinUnpaidOrderList: [],
    };
  },
  methods: {
    mixinOrderPreCheck(id, type, count = 1) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await orderPreCheck(id, type, count);
          const { action } = data;
          switch (action) {
            case 'showUnpaid': {
              const { unpaid } = data;
              this.mixinUnpaidOrderList = unpaid;
              this.mixinHandleUnpaidOrder();
              return reject();
            }
            case 'showMessage': {
              const { promptMessage } = data;
              this.mixinShowMessage(promptMessage);
              return reject();
            }
            case 'showPayPopup':
            case 'showPayCenter':
            case 'createOrder':
            case 'confirmCoinExchange':
            case 'confirmPointExchange': {
              return resolve(action);
            }
            default: {
              commonLog('orderPreCheckActionError', {
                id,
                type,
                action,
              });
              return reject();
            }
          }
        } catch (e) {
          return reject(e);
        }
      });
    },
    mixinHandleUnpaidOrder() {
      if (this.mixinUnpaidOrderList.length > 0) {
        this.mixinShowUnpaidConfirm(this.mixinUnpaidOrderList);
      }
    },
    async mixinShowUnpaidConfirm(list) {
      const { length } = list;
      const item = list[0];
      const { order, hint } = item;
      try {
        const message = `
          <div class="un-paid-order-promote-title">${hint}</div>
          <div class="un-paid-order-promote-message">${order.title}</div>`;
        await Dialog.confirm({
          title: '温馨提示',
          message,
          confirmButtonText: '继续支付',
          confirmButtonClass: 'un-paid-order-confirm-btn',
          closeOnClickOverlay: false,
        });
        let route = { name: 'OrderDetail', params: { sn: order.sn } };
        if (length > 1) {
          route = { name: 'MyOrder', query: { type: 'unpaid' } };
        }
        this.$router.push(route);
      } catch (e) {
        if (length > 1) {
          const route = { name: 'MyOrder', query: { type: 'unpaid' } };
          this.$router.push(route);
          return;
        }
        this.mixinHandleCancelOrder(order.sn);
      }
    },
    async mixinHandleCancelOrder(sn) {
      try {
        await cancelOrder(sn);
        this.mixinUnpaidOrderList.shift();
      } catch (e) {
        commonLog('cancelOrderError', {
          sn,
          e,
        });
      }
    },
  },
};

export default preCheckMixin;
